import { Injectable, Type } from '@angular/core';
import { FieldFactory } from '../field-factory.interface';
import * as fields from '../../models/settings/settings-fields-index';

import { FieldDataInterface } from '../../models/settings/settings-custom-form-field-data.model';
import { SettingsCustomFormFieldData } from '../../models/settings/settings-custom-form-field-data.class'

import * as fieldComponents from '../../components/fields/rich-text-v1/rich-text-v1-index'

@Injectable({
    providedIn: 'root'
  })
export class RichTextV1FieldFactory implements FieldFactory {
    constructor(){}
    type: string = 'rich-text-v1';
    menuTitle: string = "Rich Text";
    deprecated: boolean = false;

    /**
     * 
     * @param field the object data of the field
     * @returns RichTextV1Field instance that extends SettingsCustomFormFieldData
     */
    createFillFormFieldData(field?: FieldDataInterface): SettingsCustomFormFieldData {
        // if (field) {
        //     return new fields.RichTextV1Field(this.type, field);
        // }
        // else {
            return new fields.SettingsRichTextV1Field(this.type, 0);
        // }
    }

    createSettingsFormField(position: number) : SettingsCustomFormFieldData {
        return new fields.SettingsRichTextV1Field(this.type, position);
    }

    deserializeSettingsFormField(field: FieldDataInterface) : SettingsCustomFormFieldData {
        return new fields.SettingsRichTextV1Field(field.type, field.position, field.id, field.label, field.mandatory, field.active);
    }


    getSettingsComponentType(): Type<fieldComponents.SettingsRichTextV1FieldComponent> {
        return fieldComponents.SettingsRichTextV1FieldComponent;
    }

    getFillComponentType(): Type<fieldComponents.FillRichTextV1FieldComponent> {
        return fieldComponents.FillRichTextV1FieldComponent;
    }

    getViewComponentType(): Type<fieldComponents.ViewRichTextV1FieldComponent>{ 
        return fieldComponents.ViewRichTextV1FieldComponent;
    }


}